"use client";

import { useNav } from "@/providers/Nav";
import LogoHeader from "./LogoHeader";

export default function NavHiddenLogo() {
  const { showMainNav } = useNav();
  if (showMainNav) return null;
  return <LogoHeader />;
}
